export function makeRoute(param: string[]) {
  let routeName = '';
  param.forEach((el) => {
    routeName += '/' + el;
  });
  return routeName;
}
